import {
  Button,
  DisplayDataGrid,
  DisplayDataItem,
  FormattedCurrency,
  FormattedDate,
  Panel,
  Row,
  SectionTitle
} from '@elotech/components';
import React, { useEffect, useState } from 'react';

import { findOneObra } from '../service/ObraService';
import { useHistory } from 'react-router';

const ObraDetalheInformacao = ({
  entidade,
  exercicioObra,
  idOrdemServico,
  valorEmpenhado,
  isIntegradoOxy,
  idOxy,
  paramExibeNumeroSEI
}) => {
  const history = useHistory();
  const [obra, setObra] = useState({});

  useEffect(() => {
    findOneObra(
      entidade,
      exercicioObra,
      idOrdemServico,
      idOxy
    ).then(({ data }) => setObra(data));
  }, [setObra]);

  const getValorPercentualEmpenhado = obra => {
    let valorIntervencao = obra.valorIntervencao ? obra.valorIntervencao : 0;
    let valorAditivo = obra.valorAditivo ? obra.valorAditivo : 0;
    return ((valorEmpenhado * 100) / (valorAditivo + valorIntervencao)).toFixed(
      2
    );
  };

  const showContrato = obra => {
    const params = isIntegradoOxy
      ? `id=${obra.idOxyContrato}`
      : `entidade=${entidade}&exercicio=${obra.exercicioContrato}&contrato=${obra.contrato}&tipoAto=${obra.tipoAto}`;

    history.push(`/contratos/detalhes?${params}`);
  };

  return (
    <Panel expansible>
      <SectionTitle marginTop="0">Detalhes da Obra</SectionTitle>
      <DisplayDataGrid>
        <Row>
          <DisplayDataItem sm={6} title="Ordem Serviço / Ano">
            {`${obra.ordemServico}/${obra.exercicio}`}
          </DisplayDataItem>
          <DisplayDataItem sm={6} title="Situação">
            {obra.situacao}
          </DisplayDataItem>
        </Row>
        <Row>
          <DisplayDataItem sm={4} title="Data Início">
            {<FormattedDate value={obra.data} />}
          </DisplayDataItem>
          <DisplayDataItem sm={4} title="Previsão Término Inicial">
            {obra.previsaoTermino ? (
              <FormattedDate value={obra.previsaoTermino} />
            ) : (
              'Sem registro'
            )}
          </DisplayDataItem>
          <DisplayDataItem sm={4} title="Vigência Atualizada Contrato">
            <FormattedDate value={obra.vigenciaAtualizada} />
          </DisplayDataItem>
        </Row>
        <Row>
          <DisplayDataItem sm={4} title="Valor Intervenção">
            <FormattedCurrency value={obra.valorIntervencao} />
          </DisplayDataItem>
          <DisplayDataItem sm={4} title="Valor Contrato">
            <div>
              {<FormattedCurrency value={obra.valorContrato} />}
              <Button
                type="button"
                className="btn neutral ml-xs inline icon-right"
                onClick={() => showContrato(obra)}
              >
                Ver<em className="fa fa-external-link"></em>
              </Button>
            </div>
          </DisplayDataItem>
          <DisplayDataItem sm={4} title="Valor Aditivo">
            <FormattedCurrency value={obra.valorAditivo} />
          </DisplayDataItem>
        </Row>
        <Row>
          <DisplayDataItem sm={4} title="Medições">
            {`${obra.percentual}%`}
          </DisplayDataItem>
          {!isIntegradoOxy && (
            <DisplayDataItem sm={4} title="Percentual Empenhado">
              {`${getValorPercentualEmpenhado(obra)}%`}
            </DisplayDataItem>
          )}

          <DisplayDataItem sm={4} title="Empresa">
            {obra.empresa}
          </DisplayDataItem>
          {!isIntegradoOxy && (
            <DisplayDataItem sm={4} title="Bem (Imóvel)">
              {obra.descricaoBem}
            </DisplayDataItem>
          )}
        </Row>
        <Row>
          <DisplayDataItem sm={12} title="Objeto">
            {obra.objeto}
          </DisplayDataItem>
        </Row>
        <Row>
          <DisplayDataItem sm={12} title="População atendida">
            {obra.populacaoAtendida}
          </DisplayDataItem>
        </Row>
        <Row>
          <DisplayDataItem sm={12} title="Link Obra TCE">
            {obra.linkObraTCE ? (
              <a href={obra.linkObraTCE} target="_blank">
                {obra.linkObraTCE}
              </a>
            ) : (
              ''
            )}
          </DisplayDataItem>
        </Row>

        {paramExibeNumeroSEI === 'S' && (
          <Row>
            <DisplayDataItem sm={12} title="Nº SEI">
              {obra.numeroSei}
            </DisplayDataItem>
          </Row>
        )}
        {obra.matricula && (
          <Row>
            <DisplayDataItem sm={12} title="Fiscal técnico">
              {obra.nomeFiscal}, Matrícula: {obra.matricula}
            </DisplayDataItem>
          </Row>
        )}
        {obra.situacao === 'Paralisada' && (
          <Row>
            <DisplayDataItem md={4} title="Tipo paralisação">
              {obra.tipoParalisacao}
            </DisplayDataItem>
            <DisplayDataItem md={8} title="Motivo paralisação">
              {obra.acompMotivo}
            </DisplayDataItem>
          </Row>
        )}
      </DisplayDataGrid>
    </Panel>
  );
};

export default ObraDetalheInformacao;
